var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallEventsLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#EEF2FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2465_8974",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 21,
    height: 20
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.00098,
    y: 8,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2465_8974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3694 23.6073V21.3029H22.6323V23.9054L24.3758 25.6492L24.895 25.1298L23.3694 23.6073ZM17.8727 11.4071L12.855 14.3094L18.0008 17.2838L23.1466 14.3094L18.1289 11.4071C18.0863 11.3804 18.0436 11.3671 18.0008 11.3671C17.958 11.3671 17.9153 11.3804 17.8727 11.4071ZM10.9175 21.1619V14.8415C10.9175 14.568 10.9834 14.3175 11.1152 14.09C11.247 13.8625 11.4322 13.6792 11.6708 13.5402L17.2477 10.3302C17.3759 10.2608 17.4991 10.2092 17.6175 10.1756C17.7358 10.1419 17.8635 10.125 18.0004 10.125C18.1375 10.125 18.2687 10.1419 18.3941 10.1756C18.5197 10.2092 18.6396 10.2608 18.7539 10.3302L24.3308 13.5402C24.5694 13.6792 24.7546 13.8625 24.8864 14.09C25.0182 14.3175 25.0841 14.568 25.0841 14.8415V17.9375H23.8341V15.3446L17.98 18.7196L12.1675 15.3446V21.1492C12.1675 21.1918 12.1782 21.2319 12.1996 21.2694C12.221 21.3067 12.253 21.3388 12.2956 21.3654L17.4239 24.3415V25.7692L11.6708 22.4631C11.4322 22.3241 11.247 22.1408 11.1152 21.9133C10.9834 21.6858 10.9175 21.4353 10.9175 21.1619ZM23.0008 27.4808C21.9603 27.4808 21.0751 27.116 20.3454 26.3863C19.6157 25.6565 19.2508 24.7714 19.2508 23.7308C19.2508 22.6903 19.6157 21.8051 20.3454 21.0754C21.0751 20.3457 21.9603 19.9808 23.0008 19.9808C24.0414 19.9808 24.9265 20.3457 25.6562 21.0754C26.386 21.8051 26.7508 22.6903 26.7508 23.7308C26.7508 24.7714 26.386 25.6565 25.6562 26.3863C24.9265 27.116 24.0414 27.4808 23.0008 27.4808Z",
    fill: "#133F7D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallEventsLog);
export default __webpack_public_path__ + "static/media/callEventsLog.8cbe29683809df3787944ec7bd500438.svg";
export { ForwardRef as ReactComponent };